<template>
  <div class="page" v-loading="loading" element-loading-text="正在排查">
    <div class="page-title">
      <div class="title-name">发文排查</div>
      <div class="title-btn">
        <div class="yes btn" @click="newCheckContent">
          <img src="@/assets/img/troubleshoot/start.png" />
          <span>开始校对</span>
        </div>
        <el-popover
          v-if="form.proofreadType === 1"
          trigger="click"
          placement="bottom-end"
        >
          <div class="popover-content">
            <el-row class="row-item">
              <span class="popover-title">排查方式：</span>
              <el-radio-group class="popover-value" v-model="form.checkType">
                <el-radio :label="1">查全</el-radio>
                <el-radio :label="0">查准</el-radio>
              </el-radio-group>
            </el-row>
            <el-row class="row-item">
              <span class="popover-title">校对项：</span>
              <el-checkbox-group
                class="popover-value column"
                v-model="form.checkFunctionList"
              >
                <el-row class="value-item-1">
                  <el-checkbox :disabled="disableStatus(1)" :label="1"
                    >错词</el-checkbox
                  >
                  <el-checkbox :disabled="disableStatus(2)" :label="2"
                    >敏感词</el-checkbox
                  >
                  <el-checkbox :disabled="disableStatus(4)" :label="4"
                    >地址等词汇</el-checkbox
                  >
                </el-row>
                <el-row class="value-item-2">
                  <el-checkbox :disabled="disableStatus(64)" :label="64"
                    >空格校对</el-checkbox
                  >
                  <el-checkbox :disabled="disableStatus(8)" :label="8"
                    >标点符号</el-checkbox
                  >
                </el-row>
                <el-row class="value-item-2">
                  <el-checkbox :disabled="disableStatus(256)" :label="256"
                    >法律法规校对</el-checkbox
                  >
                  <el-checkbox :disabled="disableStatus(128)" :label="128"
                    >重复内容校对</el-checkbox
                  >
                </el-row>
                <el-row class="value-item-2">
                  <el-checkbox :disabled="disableStatus(16)" :label="16"
                    >时政热点校对</el-checkbox
                  >
                </el-row>
              </el-checkbox-group>
            </el-row>
          </div>
          <div slot="reference" class="btn">
            <img src="@/assets/img/troubleshoot/option.png" />
            <span>排查设置</span>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="content-card">
      <div class="content-main">
        <div class="content-main-left">
          <div class="head">
            <div class="head-left">
              <img src="@/assets/img/troubleshoot/title-tag.png" />
              <span class="title">排查分析内容</span>
            </div>
            <div class="head-right">
              <div class="info" v-if="form.proofreadType === 1">
                <span :style="{ color: textNum > leftCount ? 'red' : '' }"
                  >{{ textNum }} /</span
                >
                <span class="total">{{ leftCount }}（本月剩余校验字符数）</span>
              </div>
              <div class="btn" @click="remove">清空</div>
            </div>
          </div>
          <div
            class="divcont"
            ref="content"
            @paste.prevent="handlePaste"
            @keydown.enter.prevent="handleEnter"
            @input="handleTextChange"
            contenteditable="true"
            placeholder="请输入排查分析内容"
          ></div>
        </div>
        <div class="content-main-right">
          <div class="head">
            <div class="head-left">
              <img src="@/assets/img/troubleshoot/title-tag.png" />
              <span class="title">排查内容错误列表</span>
            </div>
            <div class="head-right" v-if="this.errList?.length">
              <div class="btn" @click="oneFilterText">一键校正</div>
            </div>
          </div>

          <el-card
            class="card-box"
            :style="{ borderColor: classInfo(item.planName) }"
            shadow="hover"
            v-for="(item, index) in errList"
            :key="index"
          >
            <div class="success-tag" v-if="item.success">
              <i class="el-icon-success"></i>
            </div>
            <div class="box-card">
              <el-link
                :style="{ color: classInfo(item.planName) }"
                class="error"
                :underline="false"
                >{{ item.mistakeWord }}</el-link
              >
              <template v-if="item.recommendWord">
                <img src="@/assets/img/troubleshoot/right.png" />
                <el-tooltip
                  class="item"
                  effect="light"
                  content="点击进行错误校正"
                  placement="top"
                >
                  <el-link type="success" @click="editErr(item)">{{
                    item.recommendWord
                  }}</el-link>
                </el-tooltip>
              </template>
            </div>
            <div class="info">{{ item.recommendCategoryName }}</div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 路由切换时，给出提示 -->
    <el-dialog
      class="dialog-box"
      title="提示"
      :visible.sync="interceptDialog"
      width="724px"
    >
      <div class="dialog-content">
        <img src="@/assets/img/troubleshoot/info.png" />
        <span class="title">操作提示</span>
        <span class="content">
          您的操作可能导致该页面数据清空，校对结果将不再保留，是否要继续操作？
        </span>
      </div>
      <template slot="footer">
        <div class="dialog-footer">
          <el-button @click="goRouteYes">我已知晓，继续操作</el-button>
          <el-button @click="interceptDialog = false" type="primary"
            >暂不操作</el-button
          >
        </div>
      </template>
    </el-dialog>
    <!-- 字符超出上限 -->
    <el-dialog
      class="dialog-box"
      title="提示"
      :visible.sync="characterDialog"
      width="724px"
    >
      <div class="dialog-content">
        <img src="@/assets/img/troubleshoot/info.png" />
        <span class="title">字符已超限</span>
        <template v-if="leftCount > 0">
          <span class="content">
            您输入的文本已超过{{ leftCount }}个字符限制，请删减内容至{{
              leftCount
            }}字符以内。
          </span>
        </template>
        <template v-else> 您本月剩余校验字符数已用完 </template>
      </div>
      <template slot="footer">
        <div class="dialog-footer">
          <el-button type="primary" @click="characterDialog = false"
            >确定</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Title from "../settings/components/Title.vue";
import {
  checkContent, //排查内容
  proofread,
  getLeftCount,
  getOrgInfo,
} from "../../api/troubleshoot/index";
import { disableStatus } from "@/api/account";
export default {
  components: {
    Title,
  },
  data() {
    return {
      content: "", //内容
      redContent: "",
      special_misre: 1, //错误表述
      ordinary_misre: 1, //错别字
      loading: false, //排查中
      errList: [], //错误列表
      toPath: "",
      interceptDialog: false,
      characterDialog: false,
      startCharacter: false,
      leftCount: 0,
      placeholder: "请输入排查内容",
      form: {
        checkType: 1,
        checkFunctionList: [1, 2, 4, 64, 8, 256, 128, 16],
        proofreadType: 1, // 发文排查类型：0-自研算法 1-爱校对
      },
    };
  },

  computed: {
    textNum() {
      return this.redContent.length;
    },
  },
  methods: {
    // 与接口 text / mistakeIndex 共用同一份基准文本
    syncRedContent() {
      const text = (this.$refs.content?.innerText || "")
        .replace(/\r/g, "")
        .trim();
      this.redContent = text;
      return text;
    },
    handleTextChange() {
      this.syncRedContent();
    },
    // 粘贴事件
    handlePaste(e) {
      // 获取剪贴板中的纯文本内容，去掉 \r 避免索引偏移
      const text = e.clipboardData.getData("text/plain").replace(/\r/g, "");
      // 保留空格和换行（将换行符转换为 <br>）
      const formattedText = text.replace(/\n/g, "<br>").replace(/ /g, "&nbsp;");
      // 将处理后的文本插入到光标位置
      document.execCommand("insertHTML", false, formattedText);
      this.syncRedContent();
    },
    // 处理Enter键按下
    handleEnter() {
      // 插入 <br>
      document.execCommand("insertLineBreak", false, null);
      this.syncRedContent();
    },
    async newCheckContent() {
      // 校对前冻结基准文本，保证请求与高亮使用同一份
      const proofText = this.syncRedContent();
      if (!proofText) {
        this.$message.warning("内容不能为空");
        return;
      }
      if (this.form.proofreadType == 1 && this.textNum > this.leftCount) {
        this.characterDialog = true;
        return;
      }
      // 开始校对
      this.startCharacter = true;
      // 阻止menu的点击
      this.$bus.$emit("intercept", true);
      this.loading = true;
      let params = {};
      if (this.form.proofreadType == 0) {
        params.proofreadType = 0;
      } else {
        params = this.form;
      }
      try {
        let { data: res } = await proofread({
          ...params,
          text: proofText,
        });
        if (!res.data?.length) {
          this.removeErrStatus();
          this.$message.warning("当前内容没有错误词！");
          return;
        }
        let newRes = res.data.map((item) => {
          return {
            ...item,
            success: false,
          };
        });
        this.errList = newRes.filter((item) => item.mistakeWord != "\n");
        // 跳转原文内容样式（必须基于 proofText / redContent）
        this.htmlHandler(proofText);
        this.loading = false;
      } catch {
        this.removeErrStatus();
      } finally {
        // 查剩余字符数
        this.requestLeftCount();
        this.loading = false;
      }
    },
    disableStatus(val) {
      if (this.form.checkFunctionList.length === 1) {
        return this.form.checkFunctionList[0] === val;
      }
      return false;
    },
    classInfo(val) {
      let map = new Map([
        ["重要性错误", "#bd3124"],
        ["一般性错误", "#57a5fc"],
        ["自定义", "#59bc6e"],
        ["敏感词", "#5f70fb"],
        ["标点错误", "#d561c5"],
      ]);
      return map.get(val) || "red";
    },
    remove() {
      this.removeErrStatus();
      this.$refs.content.innerHTML = "";
      this.redContent = "";
    },
    removeErrStatus() {
      this.errList = [];
      this.startCharacter = false;
      this.$bus.$emit("intercept", false);
    },
    // 错误文本高亮处理（text 必须与 proofread 的 text 一致）
    htmlHandler(text = this.redContent) {
      let result = "";
      let lastIndex = 0;
      // 首先处理所有错误项，收集所有需要高亮的区间
      const allHighlights = [];
      this.errList.forEach((item, index) => {
        if (item.mistakeIndex?.length) {
          item.class = `error_${index}`;
          item.mistakeIndex.forEach(([start, end]) => {
            const sliced = text.slice(start, end);
            // 索引与错误词不一致时跳过，避免标错位置
            if (item.mistakeWord && sliced !== item.mistakeWord) {
              console.warn(
                "[proofread] mistakeIndex 与 mistakeWord 不一致",
                { mistakeWord: item.mistakeWord, sliced, start, end }
              );
              return;
            }
            allHighlights.push({
              start,
              end,
              className: `error_${index}`,
              color: this.classInfo(item.planName),
            });
          });
        }
      });

      // 按起始位置排序，避免重叠区域处理错误
      allHighlights.sort((a, b) => a.start - b.start);

      // 处理所有高亮区域
      allHighlights.forEach((highlight) => {
        if (highlight.start < lastIndex) return;
        // 添加非高亮部分
        if (lastIndex < highlight.start) {
          result += text.slice(lastIndex, highlight.start);
        }

        // 添加高亮部分
        const html = `<span contenteditable='false' class='${
          highlight.className
        }' style='text-decoration: underline wavy ${highlight.color}; color: ${
          highlight.color
        }'>${text.slice(highlight.start, highlight.end)}</span>`;
        result += html;
        lastIndex = highlight.end;
      });

      // 添加最后剩余的部分
      if (lastIndex < text.length) {
        result += text.slice(lastIndex);
      }
      this.$refs.content.innerHTML = result.replace(/\n/g, "<br>");
    },
    // 点击修改错误
    editErr(item) {
      if (!item.recommendWord) return;
      item.success = true;
      let childs = document.querySelectorAll(`.${item.class}`);
      if (childs?.length) {
        childs.forEach((child) => {
          child.style.textDecoration = "none";
          child.style.color = "#333";
          child.innerText = item.recommendWord;
          child.setAttribute("contenteditable", "true");
        });
      }
    },
    async requestLeftCount() {
      let res = await getLeftCount();
      if (res.data.code === 200) {
        this.leftCount = res.data.data || 0;
      }
    },
    async requestOrgInfo() {
      let user = JSON.parse(localStorage.getItem("user"));
      let res = await getOrgInfo(user.orgId);
      if (res.data.code === 200) {
        this.form.proofreadType = res.data.data.proofreadType;
        // this.form.proofreadType = 0;
      }
    },
    goRouteYes() {
      this.startCharacter = false;
      this.$bus.$emit("intercept", false);
      this.$router.push({
        path: this.toPath,
      });
    },
    oneFilterText() {
      this.errList.forEach((item) => {
        this.editErr(item);
      });
    },
  },
  mounted() {
    this.requestLeftCount();
    this.requestOrgInfo();
  },
  beforeRouteLeave(to, from, next) {
    if (this.startCharacter) {
      if (to.path == "/login") {
        return next();
      }
      this.interceptDialog = true;
      this.toPath = to.path;
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  .page-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 0 24px 0;
    .title-name {
      font-size: 26px;
      font-weight: 600;
      color: #1a1a1a;
    }

    .title-btn {
      display: flex;
      justify-content: flex-end;
      .btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 17px;
        margin-left: 9px;
        font-size: 16px;
        border-radius: 4px;
        background-color: #fff;
        color: #333;
        font-weight: 500;
        &:hover {
          opacity: 0.8;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          margin-top: 2px;
        }
      }
      .yes {
        background: #f58030;
        color: #ffffff;
      }
      .testbtn {
        width: 50px;
        height: 20px;
      }
    }
  }

  .content-card {
    width: 100%;
    // height: 819px;
    .content-title {
      display: flex;
      justify-content: space-between;
      .content-title-left {
        width: 75%;
      }
      .content-title-right {
        width: 24%;
      }
    }
    .content-main {
      display: flex;
      justify-content: space-between;
      .content-main-left,
      .content-main-right {
        /* 自定义滚动条 */
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        /* 定义滚动条滑块 */
        ::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #c6cacd;
        }
        height: calc(100vh - 194px);
        .head {
          height: 77px;
          display: flex;
          justify-content: space-between;
          padding-top: 30px;
          padding-bottom: 25px;
          border-bottom: 1px solid rgba(151, 151, 151, 0.2);
          font-size: 16px;
          .head-left {
            display: flex;
            .title {
              font-weight: 500;
            }
            img {
              width: 22px;
              height: 22px;
              margin-top: 3px;
            }
          }
          .head-right {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #333;
            .total {
              color: #999;
              margin-right: 10px;
            }
            .btn {
              text-align: center;
              color: #333;
              padding: 7px 14px;
              background-color: #fff;
              font-weight: 500;
              border: 1px solid #e1e1e1;
              border-radius: 4px;
              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }
      .content-main-left {
        width: 75%;
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;
        padding-top: 0;
        ::v-deep .el-textarea__inner {
          border: 0px solid red;
        }
        .divcont {
          padding-top: 16px;
          width: 100%;
          height: calc(100% - 80px);
          overflow-y: auto;
          overflow-x: hidden;
          font-size: 14px;
          color: #333;
        }
      }
      .content-main-right {
        width: 24%;
        overflow: auto;
        background: #ffffff;
        padding: 16px;
        padding-top: 0;
        border-radius: 4px;
        // margin-left: 20px;
        .el-card {
          margin-top: 16px;
        }
        .el-link {
          margin: 0 24px;
        }
        :deep(.el-card__body) {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
[contenteditable] {
  outline: 0px solid transparent; //溢出可编辑dom元素的边框
}
[contenteditable]:empty:not(:focus):before {
  content: attr(placeholder);
  color: #999; /* 灰色文字 */
  pointer-events: none; /* 防止点击占位符 */
}

.dialog-box {
  :deep(.el-dialog__title) {
    padding: 0;
    &::before {
      display: none;
    }
  }
  .dialog-footer,
  .dialog-content {
    display: flex;
    justify-content: center;
  }
  .dialog-content {
    flex-direction: column;
    align-items: center;
    img {
      margin-top: 10px;
      width: 96px;
      height: 96px;
    }
    .title {
      font-size: 22px;
      font-weight: 600;
      margin-top: 32px;
      margin-bottom: 24px;
    }
    .content {
      text-align: center;
      width: 475px;
      font-size: 16px;
      color: #333333;
      margin-bottom: 30px;
    }
  }
}
.popover-content {
  padding: 12px;
  .row-item {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    font-size: 14px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .popover-title {
    width: 80px;
    text-align: right;
    font-weight: 500;
    color: #333333;
    font-size: 16px;
    margin-right: 5px;
  }
  .popover-value {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 80px - 5px);
    margin-top: 2px;

    .value-item-1 {
      display: flex;
      align-items: center;
    }
    .value-item-2 {
      margin-top: 22px;
      display: flex;
      align-items: center;
      :deep(.el-checkbox) {
        &:first-child {
          width: 148px;
        }
      }
    }
  }
  .column {
    flex-direction: column;
  }
}

.card-box {
  position: relative;
  :deep(.el-card__body) {
    flex-direction: column !important;
  }
  .success-tag {
    font-size: 20px;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    color: #67c23a;
  }
  .box-card {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 10px;
    }
  }
  .info {
    margin-top: 5px;
    font-size: 14px;
    color: #666;
  }
}

.red {
  color: red;
}
.green {
  color: green;
}
</style>
